export const initReducer = {
  client: {
    id: -1,
    initials: "",
    alias: "",
    writeAccess: 1,
    readAccess: 1,
    isExample: 0,
    editable: 1,
    lastSaved: "",
    unlocked: 0,
    lockExpirationTime: "",
    lockMinutesLeft: 0,
  }, // seletced client
  openClientDrawer: true, // open clients drawer
  updateClients: "", // timestamp of lastChanged clients
  darkState: false, // TODO: dark mode
  path: "/timeline", // remember pathname in clients
  libraryPath: "/library/public", // remember pathname in libary
  pauseQueries: false,
  project: {
    id: 0, // 0 = myProject
    firstName: "",
    lastName: "",
    code: "",
    path: "/timeline",
    boardId: 0, // 0 = local board
  },
  sessionId: null,
  webRConsole: null,
};

export const reducer = (app, action) => {
  if (action.type === "SET_NO_CLIENT")
    return { ...app, openClientDrawer: true, client: initReducer.client };
  if (action.type === "SET_CLIENT")
    return {
      ...app,
      client: { ...initReducer.client, ...action.payload },
    };
  if (action.type === "UPDATE_CLIENT") {
    return { ...app, client: { ...app.client, ...action.payload } };
  }
  if (action.type === "SET_OPEN")
    return { ...app, openClientDrawer: action.payload };
  if (action.type === "TOGGLE_OPEN")
    return { ...app, openClientDrawer: !app.openClientDrawer };
  if (action.type === "SET_PATH") return { ...app, path: action.payload };
  if (action.type === "SET_LIBRARY_PATH")
    return { ...app, libraryPath: action.payload };
  if (action.type === "UPDATE_CLIENTS")
    return { ...app, updateClients: action.payload };
  if (action.type === "UPDATE_APP") return { ...app, ...action.payload };
  if (action.type === "PAUSE_QUERIES")
    return { ...app, pauseQueries: action.payload };
  if (action.type === "SET_PROJECT")
    return {
      ...app,
      project: action.payload,
      client: initReducer.client,
      openClientDrawer: true,
    };
  if (action.type === "SET_SESSION_ID")
    return { ...app, sessionId: action.payload };
  if (action.type === "SET_WEBR_CONSOLE")
    return { ...app, webRConsole: action.payload };
  return app;
};
